import React from 'react';
import { Users, MessageSquare, FileText, Share2 } from 'lucide-react';

const TILES = [
  ['patients', 'Patients', Users],
  ['messages', 'Messages', MessageSquare],
  ['documents', 'Documents sent', FileText],
  ['referrals', 'Referrals', Share2],
];

export const OfficeStats = ({ stats, testId, dark = false }) => (
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid={testId}>
    {TILES.map(([k, label, Icon]) => (
      <div key={k} className={`rounded-lg p-3 ${dark ? 'bg-white/10' : 'bg-slate-50'}`}>
        <div className={`flex items-center gap-1.5 text-xs font-medium ${dark ? 'text-slate-300' : 'text-slate-500'}`}><Icon className="w-3.5 h-3.5" />{label}</div>
        <div className={`mt-1 text-2xl font-bold ${dark ? 'text-white' : 'text-slate-900'}`} data-testid={`${testId}-${k}`}>{(stats?.[k] || 0).toLocaleString()}</div>
      </div>
    ))}
  </div>
);
